import { ofType } from "redux-observable";
import { combineLatest } from "rxjs";
import { from } from "rxjs/internal/observable/from";
import { switchMap } from "rxjs/operators";
import { selectBalancingPackages, selectBalancingPackagesByPartialName, } from "../../../../balancingSelectors/selectBalancingPackages";
import { arrayInitialPackagesTypes } from "../../../../constants/arrayInitialPackagesTypes";
import { webExclusivePackageName } from "../../../../constants/webExclusives";
import { TypeActionBalancing } from "../../../balancing/actionBalancing";
import { TypeActionPlayerInfo } from "../../player/actionPlayerInfo";
import { actionRequestPurchasePackageInfo, actionSetPackageInfo, } from "../actionSetPurchasePackageInfo";
export var epicConvertReceivedPackageInfo = function (action$, state$, deps) {
    var balancingRegistered$ = action$.pipe(ofType(TypeActionBalancing.Registered));
    var playerInfo$ = action$.pipe(ofType(TypeActionPlayerInfo.Received));
    return combineLatest(balancingRegistered$, playerInfo$).pipe(switchMap(function () {
        var rawPackages = selectBalancingPackages();
        // packages => values
        var packagesArray = Array.from(rawPackages.values());
        // packageId => value
        var fixedPackages = Array.from(packagesArray.values()).filter(function (currentPackage) {
            return currentPackage.type !== undefined &&
                arrayInitialPackagesTypes.indexOf(currentPackage.type) >= 0;
        });
        var ids = fixedPackages.map(function (currentPackage) { return currentPackage.id; });
        var webExclusivePackages = selectBalancingPackagesByPartialName(webExclusivePackageName);
        var webExclusiveIds = webExclusivePackages.map(function (element) { return element.id; });
        ids = ids.concat(webExclusiveIds);
        return from([
            actionRequestPurchasePackageInfo(ids),
            actionSetPackageInfo(fixedPackages),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/purchase-packages/epics/epicConvertReceivedPackageInfo.ts
// module id = 1946
// module chunks = 3